"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentedPicker = void 0;
var react_1 = __importStar(require("react"));
var system_1 = require("../system");
var utils_1 = require("../utils");
var Box_1 = require("./Box");
var Button_1 = require("./Button");
var Typography_1 = require("./Typography");
var useStyles = (0, system_1.makeStyles)(function (theme) { return ({
    container: {
        backgroundColor: theme.go.schemes.colors.system.ButtonMinor,
        padding: "0 ".concat(theme.go.schemes.spacing.units.XS / 2, "px"),
        borderRadius: 16,
        overflow: 'hidden',
        height: 40,
        maxHeight: '100%',
        width: function (_a) {
            var flex = _a.flex;
            return (flex ? '100%' : undefined);
        },
    },
    itemContainer: {
        flex: function (_a) {
            var length = _a.length, flex = _a.flex;
            return (flex ? "0 0 calc(100% / ".concat(length, ")") : undefined);
        },
        maxWidth: function (_a) {
            var length = _a.length, flex = _a.flex;
            return (flex ? "calc(100% / ".concat(length, ")") : undefined);
        },
        width: function (_a) {
            var flex = _a.flex;
            return (flex ? 0 : undefined);
        },
    },
    divider: {
        width: 1,
        background: theme.go.schemes.colors.system.Divider,
        borderRadius: 2,
        margin: '8px 0.5px',
    },
    item: __assign({ margin: "".concat(theme.go.schemes.spacing.units.XS / 2, "px 0"), minHeight: "calc(100% - ".concat(theme.go.schemes.spacing.units.XS, "px) !important"), height: "calc(100% - ".concat(theme.go.schemes.spacing.units.XS, "px) !important"), padding: "0 ".concat(theme.go.schemes.spacing.units.L, "px"), borderRadius: '14px !important', position: 'relative', overflow: 'hidden', boxShadow: 'unset !important' }, theme.go.mixins.effects),
    active: {
        backgroundColor: theme.go.schemes.colors.system.BgMain,
        boxShadow: "".concat(theme.go.schemes.effects.bottomShadow, " !important"),
    },
    text: {
        overflow: 'hidden',
        display: 'inline-block',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    hidden: {
        visibility: 'hidden',
    },
}); });
function SegmentedPicker(_a) {
    var options = _a.options, initialValue = _a.initialValue, onChange = _a.onChange, flex = _a.flex, outerClasses = _a.classes;
    var classes = useStyles({ length: options === null || options === void 0 ? void 0 : options.length, flex: flex });
    var _b = __read((0, react_1.useState)(initialValue !== null && initialValue !== void 0 ? initialValue : options[0]), 2), value = _b[0], setValue = _b[1];
    var handleChange = (0, react_1.useCallback)(function (option) { return function () {
        setValue(option);
        onChange === null || onChange === void 0 ? void 0 : onChange(option);
    }; }, [onChange]);
    var showDivider = (0, react_1.useCallback)(function (opt, i) {
        return i < options.length - 1 && opt !== value && options[i + 1] !== value;
    }, [value, options]);
    return (react_1.default.createElement(Box_1.Box, { flexWrap: "nowrap", flexShrink: 1, className: (0, utils_1.cn)(classes.container, outerClasses === null || outerClasses === void 0 ? void 0 : outerClasses.root) }, options === null || options === void 0 ? void 0 : options.map(function (opt, i) { return (react_1.default.createElement(Box_1.Box, { flexWrap: "nowrap", key: "".concat(i, " ").concat(opt.value), className: classes.itemContainer },
        react_1.default.createElement(Button_1.Button, { variant: opt === value ? system_1.ButtonVariants.Float : system_1.ButtonVariants.Default, startIcon: opt.startIcon, className: (0, utils_1.cn)(classes.item, outerClasses === null || outerClasses === void 0 ? void 0 : outerClasses.item, opt === value ? classes.active : ''), onClick: handleChange(opt), disabled: opt.disabled }, opt.label && (react_1.default.createElement(Typography_1.Typography, { variant: "B&G/Caption1", className: classes.text, display: "inline", title: opt.label }, opt.label))),
        i < options.length - 1 && (react_1.default.createElement("div", { className: (0, utils_1.cn)(classes.divider, showDivider(opt, i) ? '' : classes.hidden) })))); })));
}
exports.SegmentedPicker = SegmentedPicker;
